import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_NEWS_CATEGORY_OK = "GET_NEWS_CATEGORY_OK";
export const GET_NEWS_CATEGORY_ERR = "GET_NEWS_CATEGORY_ERR";
export const DELETE_NEWS_CATEGORY_OK = "DELETE_NEWS_CATEGORY_OK";
export const DELETE_NEWS_CATEGORY_ERR = "DELETE_NEWS_CATEGORY_ERR";
export const CREATE_NEWS_CATEGORY_ERR = "CREATE_NEWS_CATEGORY_ERR";
export const UPD_NEWS_CATEGORY_ERR = "UPD_NEWS_CATEGORY_ERR";
export const UPD_NEWS_CATEGORY_OK = "UPD_NEWS_CATEGORY_OK";

export const newCategoryAction = {
  getNewsCategory,
  deleteNewsCategory,
  createNewsCategory,
  updNewsCategory,
};
function updNewsCategoryOk(payload) {
  return { type: UPD_NEWS_CATEGORY_OK, payload };
}
function updNewsCategoryErr(payload) {
  return { type: UPD_NEWS_CATEGORY_ERR, payload };
}
function createNewsCategoryErr(payload) {
  return { type: CREATE_NEWS_CATEGORY_ERR, payload };
}
function deleteNewsCategoryOk(payload) {
  return { type: DELETE_NEWS_CATEGORY_OK, payload };
}
function deleteNewsCategoryErr(payload) {
  return { type: DELETE_NEWS_CATEGORY_ERR, payload };
}
function getNewsCategoryOk(payload) {
  return { type: GET_NEWS_CATEGORY_OK, payload };
}
function getNewsCategoryErr(payload) {
  return { type: GET_NEWS_CATEGORY_ERR, payload };
}

function updNewsCategory(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .post(ApiUrl.UpdateNewsAdm, data)
      .then((response) => {
        //update store
        //dispatch(updNewsCategoryOk(data));
        //dispatch(RemoveOneSlotToLoadingQueue);

        //load from server
        dispatch(RemoveOneSlotToLoadingQueue);
        dispatch(getNewsCategory());
      })
      .catch((error) => {
        dispatch(updNewsCategoryErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}

function createNewsCategory(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .post(ApiUrl.CreateNewsAdm, data)
      .then((response) => {
        dispatch(RemoveOneSlotToLoadingQueue);
        dispatch(getNewsCategory());
      })
      .catch((error) => {
        dispatch(createNewsCategoryErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}

function deleteNewsCategory(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .post(ApiUrl.DeleteNewsAdm + data.Id + "/" + data.xmin)
      .then((response) => {
        dispatch(deleteNewsCategoryOk(data));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(deleteNewsCategoryErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}

function getNewsCategory(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get("api/cms/News/GetListAll?pageIndex=1&pageSize=100000")
      .then((response) => {
        dispatch(getNewsCategoryOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getNewsCategoryErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
